import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useSelector } from "react-redux";
import Link from "next/link";

import { getMenu } from "@store/selectors/menu";
import { getIsLockerShop } from "@selectors/store";

import { useStoreContext } from "@components/store/provider";

import GlobalProductSearch from "@sharedComponents/global-search/global-product-search";

import { getSelectedMenuItem } from "@helpers/menu";

import { getMenuItemRoute } from "@constants/routes";

import styles from "./main.module.scss";

const TabMenuParentCategories = () => {
  const router = useRouter();
  const { category } = router.query;
  const menu = useSelector(getMenu);
  const { storeBasePath, persistedFiltersQuery } = useStoreContext();
  const isLockerShop = useSelector(getIsLockerShop);
  const parentCategory = getSelectedMenuItem(menu, category) || {
    children: [],
  };

  const menuList = menu.children;
  const withSwag = parentCategory.forSwag;

  const hideContentForMerch = withSwag && !isLockerShop;

  if (menuList?.length === 0) return null;

  const renderScrollableCategoriesNav = () =>
    menuList.map(({ code, id, name }) => {
      const currentCategorySelected = code === category;
      return (
        <div
          className={`${styles.horizontalNavItem} ${currentCategorySelected ? "active" : ""}`}
          key={id}
        >
          <Link
            prefetch={false}
            passHref
            href={getMenuItemRoute({
              storeBasePath,
              category: code,
              query: persistedFiltersQuery,
            })}
            className={styles.horizontalNavItemLink}
          >
            <span>{name}</span>
          </Link>
        </div>
      );
    });

  return (
    <div className={styles.scrollableSearchBlock}>
      {!hideContentForMerch && <GlobalProductSearch />}
      <div
        className={`${styles.scrollableCategoriesBlock} ${
          hideContentForMerch ? styles.merchCategoryBlock : ""
        }`}
      >
        {renderScrollableCategoriesNav()}
      </div>
    </div>
  );
};

export default TabMenuParentCategories;
